export default "__VITE_ASSET__3aa245f8__"